import { FC, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/reducers";
import { Blocked_Input_List } from "../../../constants/validation.constants";
import TextField from "@mui/material/TextField";
import "../../../assets/scss/global.scss";
import Dialog, { DialogProps } from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
  import downloadIcon from "../../../assets/images/downloadIcon.svg";

import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import styles from "./ReportExportDialog.module.scss";
import "./ReportExportDialog.scss";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Loader from "components/loader";
import { getGenerateReport } from "services/GenerateReport.service";
import { getCurrentUTCTime } from "utilities/dateFormatter";
import { getPayloadLanguage } from "utilities/helper";

interface Props {
  onClose: () => void;
  onExport: () => void;
}

const ReportExportDialog: FC<Props> = ({ onClose, onExport }) => {
  const { t } = useTranslation();
  const history = useNavigate();
  const [OpenPopup, setOpenPopup] = useState(true);
  const [securedFileName, setScuredFileName] = useState(true);
  const [isReportExporting, setIsReportExporting] = useState(false);
  const [isReportDownloaded, setIsReportDownloaded] = useState(false);
  const [isReportNameValid, setIsReportNameValid] = useState(true);
  const { filterPayloads } = useSelector((state: RootState) => {
    return state.filters;
  });
  // const [openExportPopUpNext, setopenExportPopUpNext] = useState(false);

  const [maxWidth] = useState<DialogProps["maxWidth"]>("sm");

  const [downloadFileName, setDownloadFileName] = useState(
    "Reward Benchmarking - " + getCurrentUTCTime()
  );
  const { countryDetails } = useSelector((state: any) => {
    return state.country;
  });
  // const handleCloseExport = () => {
  //   setopenExportPopUpInitial(false);
  //   setopenExportPopUpNext(true);
  //   onClose();
  // };

  const handleClose = (event: any, reason: string) => {
    if (reason && reason === "backdropClick") return;
    setOpenPopup(false);
    onClose();
  };

  const downloadReport = async (event: any) => {
    setIsReportExporting(true);
    const requestPayload = {
      ...filterPayloads,
      language: getPayloadLanguage(),
      reportName: downloadFileName,
      gradeId: "ALL",
      aggregationMethod: "ORG",
      peerGroupKey: "ALL",
      isBroaden: "0",
      isDerivedStatistic: "0",
      isAlphaMedian: "False",
      gradeForAlphaMedian: "ALL"
    };

    try {
      const response = await getGenerateReport(requestPayload);
      response && response?.responseCode === 200 && setIsReportDownloaded(true);
    } catch (error) {
      console.log(error);
    } finally {
      setIsReportExporting(false);
    }
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    let value = event.target.value;
    // value = value.replace(/[^a-zA-Z ]/g, "");
    setDownloadFileName(value);
    setIsReportNameValid(value?.trim().length > 0);
    validateFileName(value);
  };

  const validateFileName = (name = "") => {
    // removed the below line as it was casuing the issue with the validation of the file name and the file name was not getting updated when its empty strong  ( downloadFileName)
    name = name;
    let found: boolean = false;
    Blocked_Input_List.map((ele: any) => {
      if (name.toLowerCase().includes(ele.toLowerCase())) {
        found = true;
      }
    });
    if (found && name?.trim().length > 0) {
      setScuredFileName(false);
    } else {
      setScuredFileName(true);
    }
    return !found;
  };
  const render = () => {
    return (
      <>
        {/* <Dialog
          className={styles.MuiDialogRoot}
          open={openExportPanel}
          onClose={handleCloseExport}
          aria-labelledby="scroll-dialog-title"
          aria-describedby="scroll-dialog-description"
          fullWidth={fullWidth}
          maxWidth={maxWidth}
        >
          <header className={styles.MuiHeader}>
            <DialogTitle>Prepare Export</DialogTitle>
            <DialogContent className={styles.MuiDescriptionText1}>
              Export reward benchmarking
            </DialogContent>
            <DialogContent className={styles.MuiDescriptionText2}>
              <h5>Download Australia total reward benchmarking spreadsheet</h5>
            </DialogContent>
          </header>
          <DialogContent
            id="scroll-dialog-description"
            className={styles.MuiDialogContentBody}
          >
            <FormControl variant="standard" fullWidth>
              <label className={styles.MuiLabel}> Raise/Lower Pay %</label>
              <Box className={styles.MuiBoxStyle}>
                <TextField
                  helperText="Minimum - 100"
                  id="demo-helper-text-aligned"
                  size="small"
                  type="number"
                  defaultValue="0"
                  className={styles.MuiTextFieldLeft}
                  fullWidth
                />
                <TextField
                  helperText="Maximum - 500"
                  id="demo-helper-text-aligned-no-helper"
                  size="small"
                  type="number"
                  defaultValue="0"
                  fullWidth
                  className={styles.MuiTextFieldRight}
                  style={{ appearance: "none" }}
                />
              </Box>
              <label className={styles.MuiLabel}>
                Market Position{" "}
                <span>
                  <small>Related data wil come here</small>
                </span>
              </label>
              <TextField
                id="outlined-select-currency"
                size="small"
                select
                fullWidth
              >
                {marketPositions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </TextField>
              <label className={styles.MuiLabel}> Raise/Lower Market %</label>
              <Box className={styles.MuiBoxStyle}>
                <TextField
                  helperText="Minimum - 100"
                  id="demo-helper-text-aligned"
                  className={styles.MuiTextFieldLeft}
                  size="small"
                  fullWidth
                />
                <TextField
                  helperText="Maximum - 500"
                  id="demo-helper-text-aligned-no-helper"
                  className={styles.MuiTextFieldRight}
                  size="small"
                  fullWidth
                />
              </Box>
              <label className={styles.MuiLabel}> Target Range %</label>
              <Box className={styles.MuiBoxStyle}>
                <TextField
                  helperText="Minimum - 100"
                  id="demo-helper-text-aligned"
                  className={styles.MuiTextFieldLeft}
                  size="small"
                  fullWidth
                />
                <TextField
                  helperText="Maximum - 500"
                  id="demo-helper-text-aligned-no-helper"
                  className={styles.MuiTextFieldRight}
                  size="small"
                  fullWidth
                />
              </Box>
              <label className={styles.MuiLabel}> Report Options</label>
              <FormControlLabel
                className={styles.MuiFormControlLabel}
                control={<Checkbox name="disable-query" />}
                label="Disable query broadening"
              />
              <FormControlLabel
                className={styles.MuiFormControlLabel}
                control={<Checkbox name="use-derived" />}
                label="Use Derived Statistics"
              />
              <FormControlLabel
                className={styles.MuiFormControlLabel}
                disabled
                control={<Checkbox name="include-alpha" />}
                label="Include Alpha-statistics"
              />
              <label className={styles.MuiLabel}> Aggregation method</label>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                defaultValue="organization"
                name="radio-buttons-group"
                row
              >
                <FormControlLabel
                  value="organization"
                  className={styles.MuiFormControlLabel}
                  control={<Radio />}
                  label="Organization Weighting"
                />
                <FormControlLabel
                  value="incumbent"
                  className={styles.MuiFormControlLabel}
                  control={<Radio />}
                  label="Incumbent Weighting"
                />
              </RadioGroup>
            </FormControl>
          </DialogContent>
          <footer>
            <DialogActions className={styles.MuiDialogActionNext}>
              <KFButton
                onClick={() => {
                  handleCloseExport(event, "Close");
                }}
              >
                Next
              </KFButton>
            </DialogActions>
          </footer>
        </Dialog> */}

        <Dialog
          className={`hide-scroll ${styles.MuiDialogRoot}`}
          open={OpenPopup}
          onClose={handleClose}
          maxWidth={maxWidth}
        >
          {!isReportDownloaded ? (
            <>
              {isReportExporting && <Loader />}
              <header className={styles.MuiHeaderText}>
                <div onClick={() => handleClose(event, "close")}>
                  <HighlightOffIcon
                    className={styles.closeIcon}
                    fontSize="small"
                  ></HighlightOffIcon>
                </div>
                <div className={styles.HeaderContent}>
                  <DialogTitle>
                    <img src={downloadIcon} alt="Download Icon" />
                  </DialogTitle>{" "}
                  <DialogContent className={styles.MuiDescriptionText1}>
                    {t("pa.exportReportDialogHeading")}
                  </DialogContent>
                </div>
              </header>
              <DialogContent className={styles.MuiDialogContentBodySecondary}>
                <FormControl variant="standard" fullWidth>
                  <label className={styles.MuiLabel}>
                    <b>{t("pa.exportReportDialog.nameYourXlsxFile")}</b>
                  </label>
                  <TextField
                    id="outlined-select-currency"
                    size="small"
                    value={downloadFileName}
                    fullWidth
                    className="inputBorder"
                    onChange={handleChange}
                    error={!isReportNameValid}
                    helperText={
                      !isReportNameValid && "Please enter a valid filename"
                    }
                  ></TextField>
                  {!securedFileName && (
                    <div className="blocked-file-name">
                      {t("pa.invalidFileName")}
                    </div>
                  )}
                  {t("pa.exportReportDialog.summary")}
                </FormControl>
              </DialogContent>
              <footer>
                <DialogActions className={styles.MuiDialogActions}>
                  <Button
                    onClick={() => {
                      handleClose(event, "close");
                    }}
                    variant="outlined"
                  >
                    {t("pa.cancel")}
                  </Button>

                  <Button
                    onClick={(event) => {
                      isReportNameValid &&
                        validateFileName() &&
                        downloadReport(event);
                    }}
                    variant="contained"
                    disabled={!isReportNameValid || !securedFileName}
                  >
                    {t("pa.exportReportBtn")}
                  </Button>
                </DialogActions>
              </footer>
            </>
          ) : (
            <>
              {" "}
              <header className={styles.MuiHeaderText}>
                <DialogContent className={styles.MuiExportInprogressTitle}>
                  {t("pa.exportInProgress")}
                </DialogContent>
                <div onClick={() => handleClose(event, "close")}>
                  <HighlightOffIcon
                    className={styles.closeIcon}
                    fontSize="small"
                  ></HighlightOffIcon>
                </div>
              </header>
              <DialogContent className={styles.MuiExportInprogressBody}>
                {t("pa.exportInProgressDescription1")}
                <span
                  className={styles.MuiExportInprogressBodyMyReportsLink}
                  onClick={() => {
                    history("/pay-analytics/my-reports");
                    handleClose(event, "close");
                  }}
                >
                  {" "}
                  <b>{t("pa.myreports")}</b>
                </span>{" "}
                {t("pa.exportInProgressDescription2")}
              </DialogContent>
              <footer>
                <DialogActions className={styles.MuiDialogActions}>
                  <Button
                    onClick={() => {
                      history("/pay-analytics/my-reports");
                      handleClose(event, "close");
                    }}
                    variant="outlined"
                  >
                    {t("pa.goToMyReports")}
                  </Button>

                  <Button
                    onClick={() => {
                      handleClose(event, "close");
                    }}
                    variant="contained"
                  >
                    {t("pa.close")}
                  </Button>
                </DialogActions>
              </footer>
            </>
          )}
        </Dialog>
      </>
    );
  };

  return render();
};

export default ReportExportDialog;
